import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from "@/store";
import http from "@/utils/http";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' ,requiresAuth: false}
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '账号控制面板', icon: 'el-icon-s-home' ,requiresAuth: true}
      },
      {
        path: 'product-popup',
        name: 'ProductPopup',
        component: () => import('@/views/product-popup/index.vue'),
        meta: { title: '商品自动弹窗', icon: 'el-icon-goods' ,requiresAuth: true}
      },
      {
        path: 'text-control',
        name: 'TextControl',
        component: () => import('@/views/text-control/index.vue'),
        meta: { title: '智能文字场控', icon: 'el-icon-chat-dot-round',requiresAuth: true }
      },
      {
        path: 'text-reply',
        name: 'TextReply',
        component: () => import('@/views/text-reply/index.vue'),
        meta: { title: '智能文字回复', icon: 'el-icon-message' ,requiresAuth: true}
      },
      {
        path: 'voice-control',
        name: 'VoiceControl',
        component: () => import('@/views/voice-control/index.vue'),
        meta: { title: '智能语音场控', icon: 'el-icon-microphone' ,requiresAuth: true}
      },
      {
        path: 'voice-reply',
        name: 'VoiceReply',
        component: () => import('@/views/voice-reply/index.vue'),
        meta: { title: '智能语音回复', icon: 'el-icon-headset' ,requiresAuth: true}
      },
      {
        path: 'product-collect',
        name: 'ProductCollect',
        component: () => import('@/views/product-collect/index.vue'),
        meta: { title: '直播商品采集', icon: 'el-icon-upload2' ,requiresAuth: true,platform_type:[1]}
      },
      {
        path: 'audio-dedup',
        name: 'AudioDedup',
        component: () => import('@/views/audio-dedup/index.vue'),
        meta: { title: '音频去重播放', icon: 'el-icon-video-play' ,requiresAuth: true}
      },
      {
        path: 'audio-cut',
        name: 'AudioCut',
        component: () => import('@/views/audio-cut/index.vue'),
        meta: { title: '音频智能剪碎', icon: 'el-icon-scissors' ,requiresAuth: true}
      },
      {
        path: 'alert',
        name: 'Alert',
        component: () => import('@/views/alert/index.vue'),
        meta: { title: '直播预警设置', icon: 'el-icon-warning' ,requiresAuth: true,platform_type:[1]}
      },
      {
        path: 'troll-detect',
        name: 'TrollDetect',
        component: () => import('@/views/troll-detect/index.vue'),
        meta: { title: '智能识别黑粉', icon: 'el-icon-user-solid',requiresAuth: true,platform_type:[1,5] }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})



// 修复 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}





router.beforeEach( (to, from, next) => {
  const token = store.getters.token


  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if ((to.path === '/login') && token) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
